import { settledDebouncedCalls } from './debounce'

/**
 * How many cart writes that `debounceById` does not track have settled since
 * the page loaded: delete-product, clear-cart, prefill and chosen free goods
 * (COM-1512).
 */
let settledUntrackedWrites = 0

/**
 * Counts one settled cart write that does not go through `debounceById`.
 * Each such writer calls it once per request, first thing in its mutation's
 * `onCompleted` and in its `onError`, so a success and a failure both count,
 * as a debounced write's settle does: a failed request may still have
 * changed the cart on the server. It is synchronous and runs before the
 * write's cart reaches the store, so anything that checks the count after
 * that cart is on screen sees it moved. Nothing waits for these writes; the
 * count only lets a reader tell that one answered (COM-1512).
 */
export const noteCartWriteSettled = (): void => {
  settledUntrackedWrites += 1
}

/**
 * A count that moves each time any cart write settles, debounced or not. A
 * cart read that spans a change in it may be older than a cart write that
 * has already answered, so `refreshCatalog` reads the cart again (COM-1500,
 * COM-1512). It is the debounced count (`settledDebouncedCalls`) plus the
 * untracked one, rather than the debounce reporting here, so the debounce
 * module and its count stay as they were, and it reads
 * `settledDebouncedCalls` exactly once per call. Only its changes mean
 * anything, never its value.
 */
export const settledCartWrites = (): number =>
  settledDebouncedCalls() + settledUntrackedWrites
